"use client";

import type { ProtocolMetadata } from "@/types";
import React, { Fragment, type PropsWithChildren, useMemo } from "react";

import ProtocolHeader from "@/components/Protocol/Header";
import { useParams, usePathname } from "next/navigation";

export default function ProtocolLayout({ children, singleProtocol }: PropsWithChildren<{ singleProtocol: ProtocolMetadata }>) {
  const pathname = usePathname();
  const { slug } = useParams();

  const currentTab = useMemo(() => {
    return pathname.replace(`/protocol/${slug}/`, "").replace("/", "") || "about";
  }, [pathname, slug]);

  return (
    <Fragment>
      <ProtocolHeader slug={slug as string} singleProtocol={singleProtocol} currentTab={currentTab} />
      {children}
    </Fragment>
  );
}
